import { Button, Flex, Box, Text } from 'rebass';
import { Form, useField, Field, ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import UAParser from 'ua-parser-js';

import MarkdownEditor from '../../app/form/formik/markdown-editor';
import TextArea from '../../app/form/formik/auto-grow';

export const EditorStyle = {
  padding: "10px 0px",
  paddingBottom: '30px',
  paddingTop: '0px',
  fontSize: '16px',
  minHeight: '40vh',
  maxHeight: '40vh',
  outline: 'none',
  border: 0,
  borderTop: '1px solid #E2E8F0',
  borderBottom: '1px solid #E2E8F0',
  maxWidth: '100vw',
  overflowY: 'auto',
  resize: 'none',
  width: '100%',
  boxSizing: 'border-box',
  whiteSpace: 'pre-wrap'
}

export const AndroidFieldWrap = styled.div`
  textarea {
    outline: none;
    font-size: 17px;
    border: none;
    width: 100%;
    resize: none;
    padding: 1em;
    font-family: inherit;
  }
`;

const TextForm = ({ isSubmitting, name = "text", onCancel, showCount, maxChars = 84 }) => {
  const isAndroid = UAParser(navigator.userAgent).os.name === 'Android';
  const [field] = useField(name);
  const [characterCount, setCharacterCount] = useState(0);

  useEffect(() => {
    const textOnly = String(field.value || "").replace(/<\/p\s*>/gi, '\n')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<[^>]*>/g, '')
      .trim();

    setCharacterCount(textOnly.length);
  }, [field.value]);

  return (
    <Form as={Box} minHeight={300}>
      {isAndroid ? (
        <AndroidFieldWrap>
          <Field
            name={name}
            component={TextArea}
            type="text"
            placeholder="Add Text"
            style={EditorStyle}
          />
        </AndroidFieldWrap>
      ) : (
        <Field component={MarkdownEditor} name={name} style={EditorStyle} />
      )}
      <Flex justifyContent="space-between" alignItems="center">
        <ErrorMessage name={name}>
          {(message) => (
            <Text color="red" p={1} pt={2} fontSize={1}>
              {message}
            </Text>
          )}
        </ErrorMessage>
        {showCount && maxChars > 0 && (
          <Text
            textAlign="end"
            color={characterCount > maxChars ? 'red' : '#757575'}
            p={1} pt={2} ml="auto"
          >
            {characterCount}/{maxChars}
          </Text>
        )}
      </Flex>
      <Flex justifyContent="space-between" p={3}>
        {/* <Button
          type="button"
          variant="muted"
          onClick={onCancel}
          disabled={isSubmitting}
          mr={3}
          py={2}
          px={3}
        >
          Cancel
        </Button> */}
        <Button type="submit" variant="primary" disabled={isSubmitting} py={2} px={3}
          css="position: absolute; top: 5px; right: 5px; display: flex; align-items: center;"
        >
          Save
        </Button>
      </Flex>
    </Form>
  );
};

TextForm.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default TextForm;
